export const accreditationStatusColor = {
  'ACCREDITED': 'var(--status-success)',
  'PENDING': 'var(--color-warning)',
  'REWORKING': 'var(--status-qualification)',
  'DECLINED': 'var(--status-decline)',
}

const statusPriority = Object.keys(accreditationStatusColor)

export const sortByStatusPriority = (statuses, statusKey = 'status') => {
  return [...statuses].sort((a, b) => statusPriority.indexOf(a[statusKey]) - statusPriority.indexOf(b[statusKey]))
}
